import './_collection-secret-sale.scss';

export default () => {};
